import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from 'typedjson';
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
/** запись в журнале запусков шедулера */
let BdpkScheduleLogItem = class BdpkScheduleLogItem extends DxGridRow {
    get is_commentCutted() {
        // пришлось закомментировать по усмотрению Еврения Корякина
        // return this.isCommentCutted;
        return !!this.comment;
    }
    get is_resultCutted() {
        // пришлось закомментировать по усмотрению Еврения Корякина
        // return this.isResultCutted;
        return !!this.result;
    }
    getRowId() {
        return this.id;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get scheduleId() {
        return this._scheduleId;
    }
    set scheduleId(value) {
        this._scheduleId = value;
    }
    get scheduleName() {
        return this._scheduleName;
    }
    set scheduleName(value) {
        this._scheduleName = value;
    }
    get objectId() {
        return this._objectId;
    }
    set objectId(value) {
        this._objectId = value;
    }
    get objectName() {
        return this._objectName;
    }
    set objectName(value) {
        this._objectName = value;
    }
    get runFactDateTime() {
        return this._runFactDateTime;
    }
    set runFactDateTime(value) {
        this._runFactDateTime = value;
    }
    get statusName() {
        return this._statusName;
    }
    set statusName(value) {
        this._statusName = value;
    }
    get result() {
        return this._result;
    }
    set result(value) {
        this._result = value;
    }
    get comment() {
        return this._comment;
    }
    set comment(value) {
        this._comment = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkScheduleLogItem.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "scheduleId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkScheduleLogItem.prototype, "_scheduleId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "scheduleName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "_scheduleName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkScheduleLogItem.prototype, "_objectId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "objectName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "_objectName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "objectFilePath", void 0);
tslib_1.__decorate([
    jsonMember({ name: "runFactDateTime", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkScheduleLogItem.prototype, "_runFactDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ name: "statusName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "_statusName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "parameters", void 0);
tslib_1.__decorate([
    jsonMember({ name: "result", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "_result", void 0);
tslib_1.__decorate([
    jsonMember({ name: "comment", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "_comment", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkScheduleLogItem.prototype, "runUser", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkScheduleLogItem.prototype, "isCommentCutted", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkScheduleLogItem.prototype, "isResultCutted", void 0);
BdpkScheduleLogItem = tslib_1.__decorate([
    jsonObject
], BdpkScheduleLogItem);
export { BdpkScheduleLogItem };
